import { render } from "./theme27.vue?vue&type=template&id=7a224192&scoped=true"
import script from "./theme27.vue?vue&type=script&lang=js"
export * from "./theme27.vue?vue&type=script&lang=js"

import "./theme27.vue?vue&type=style&index=0&id=7a224192&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-7a224192"

export default script